module.exports = __webpack_public_path__ + "static/media/quiz-3.9b0c36e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quiz-3.png
// module id = 130
// module chunks = 0